import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BusinessContact } from '../models/business-contact.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../services/contact.service';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';

@Component({
  selector: 'app-edit-contact',
  templateUrl: './edit-contact.component.html',
  styleUrls: ['./edit-contact.component.scss']
})

export class EditContactComponent implements OnInit {
  contact: BusinessContact;
  originalContact: BusinessContact;
  isNew = false;
  isLoading = false;
  businessID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  constructor(private _matDialogRef: MatDialogRef<EditContactComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _contactService: ContactService) {
    this.contact = data.contact || new BusinessContact();
    this.isNew = data.isNew || false;
    this.businessID = data.busID;
    this.originalContact = Object.assign(new BusinessContact(), data.contact);
    this.itemsToChange = new Set<number> ();
    if (this.isNew) {
      this.contact.okToPublish = true;
    }
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      okToPublish: new FormControl(''),
      titleDept: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      name: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      email: new FormControl('', [Validators.maxLength(50), Validators.pattern('.+\\@.+\\..+')]),
      phone: new FormControl(formatPhoneString(this.contact.phone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')])
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.contact.phone = undoPhoneFormat(this.formGroup.get('phone').value);
      if (this.isNew) {
        res = await this._contactService.postBusinessContact(this.businessID, this.contact);
        this.contact = BusinessContact.parse(res);
      } else {
        res = await this._contactService.putBusinessContact(this.businessID, this.contact);
        Object.assign(this.contact, BusinessContact.parse(res));
        this.contact = BusinessContact.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, contact: this.contact});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * formats passed in phone number string and saves to appropriate form field.
   * @param {string} field
   * @param {string} value
   * @return {string}
   */
  formatPhoneNumber (field: string, value: string): string {
    const NEW_NUMBER: string = formatPhoneString(value);
    this.formGroup.patchValue({[field]: NEW_NUMBER});
    return NEW_NUMBER;
  }

  phoneFieldKeyUp (event, field: string, phoneInputObj) {
    const value: string = this.formGroup.get(field).value;
    const rawValue = undoPhoneFormat(value);
    const KEY = event.key;

    if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
      this.formatPhoneNumber(field, value);
    } else if (phoneInputObj.selectionStart < value.length) {
    } else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
      return;
    } else {
      this.formatPhoneNumber(field, value);
    }
  }

  /**
   * triggered when phone or fax field goes out of focus
   * @param {string} field
   */
  phoneFieldBlur(field: string) {
    const VALUE: string = this.formGroup.get(field).value;
    if (VALUE === '') {
      return;
    }
    this.formatPhoneNumber(field, VALUE);
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.contact, this.originalContact);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }

}
